module.exports = __webpack_public_path__ + "static/media/shift-right.28082e57.svg";